import React, { useState, useEffect, useRef } from "react";
import { Container, Card, Table, Button, CarouselItem, Col, Row, Stack } from "react-bootstrap";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import Widgets from "../components/Admin/Widgets";
import { useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { withAuthenticationRequired } from "@auth0/auth0-react";

const domain = process.env.REACT_APP_AUTH0_DOMAIN;

const override = {
  display: "block",
  margin: "0 auto",
};

const AdminPage = () => {
  const effectRan = useRef(false);
  const navigate = useNavigate();
  const [ tenants, setTenants ] = useState([]);
  const [ isShown, setIsShown ] = useState(false);
  const [ tenantId, setTenantId ] = useState();
  const [ loading, setLoading ] = useState(false);
  const { getAccessTokenSilently, logout, user } = useAuth0();

  const token = async () => {
    const t = await getAccessTokenSilently({
      audience: `https://${domain}/api/v2/`,
      scope: 'read:messages'
    });
    
    if (t != null) {
      //openModal();
      apiRequest(t);
    }
  }

  const apiRequest = (token) => {
      axios
        .get("api/Tenant/GetDashboardTenants", {headers: {
          "Authorization": `Bearer ${token}`
        }}).then((response) => {
          setTenants(response.data);
          setLoading(false);
        })
        .catch(function (error) {
          console.log("Tenant error");
        });
    }
  
  useEffect(() => {
    if (effectRan.current === false) {
      setLoading(true);

      token();

      return () => {
        effectRan.current = true;
      };
  };
  });

  const openModal = (event) => {
    const id = event.currentTarget.id;
    setTenantId(id);
    setIsShown(true);
  };

  const showDashboard = (event) => {
    const apiKey = event.currentTarget.id;
    navigate("/Dashboard/" + apiKey);
  };

  const updateDashboard = async () => {
    const token = await getAccessTokenSilently({
      scope: "read:messages",
      audience: `https://${domain}/api/v2/`
    });

    console.log(user);

    axios.get("api/Setup/SetupDatabase", { headers: {
      "Authorization": `Bearer ${token}` 
    }}).then((response) => {
      window.location.reload();
    }).catch(function (error) {
      window.location.reload();
    })
  } 

  return (
    <>
      <div
        id="tenantsComponent"
        style={{
          backgroundColor: "#00B1FF",
          backgroundImage: "url(https://cdn.deelfietsnederland.nl/assets/dashboard/login_background.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "50%",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
          <Container>
            <Card>
              <Card.Header>Verander de widgets van tenants</Card.Header>
              <Card.Body>
                {loading ? (
                  <ClipLoader
                    color="#5b36d6"
                    loading={loading}
                    cssOverride={override}
                    speedMultiplier="0.8"
                    size={35}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                ) : (
                  <Table striped bordered>
                    <thead className="text-center">
                      <tr>
                        <th>ID</th>
                        <th>Tenant</th>
                        <th>Controleer het dashboard</th>
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      {tenants.length === 0 ? (
                      <tr>
                        <td colSpan={3}>
                          Er is geen data gevonden. Druk <a href="#" onClick={updateDashboard}>hier</a> om de data in te laden!
                          <br/>
                          Als er hierna nog iets mis is, neem dan contact op met een beheerder.
                          </td>
                      </tr>
                      ) : (tenants.map((d) => (
                        <tr key={d.tenantID}>
                          <td>{d.tenantID}</td>
                          <td>
                            <Button
                              variant="link"
                              id={d.tenantID}
                              onClick={openModal}
                            >
                              {d.tenantName}
                            </Button>
                          </td>
                          <td>
                            <Button
                              variant="link"
                              id={d.apiKey}
                              onClick={showDashboard}
                            >
                              Bezoek dashboard
                            </Button>
                          </td>
                        </tr>
                      )))}
                    </tbody>
                  </Table>
                )}
              </Card.Body>
                <Container style={{'padding': 'var(--bs-card-spacer-y) var(--bs-card-spacer-x)'}}>
                  <Row className="row mb-3">
                    <Col className="d-flex justify-content-center"><div>Ingelogd als <span style={{ fontWeight: 'bold' }}>{user.name}</span></div></Col>
                  </Row>
                  <Row className="row justify-content-center">
                    <Col className="col-4 d-flex justify-content-center">
                      <Button onClick={() => navigate("/")}>
                        Terug naar voorpagina
                      </Button>
                    </Col>
                    <Col className="col-4 d-flex justify-content-center">
                      <Button onClick={updateDashboard}>
                        Update de database
                      </Button>
                    </Col>
                    <Col className="col-4 d-flex justify-content-center">
                      <Button onClick={() => logout({ returnTo: window.location.origin })}>
                        Log uit
                      </Button>
                    </Col>
                  </Row>
                </Container>
            </Card>
            {isShown === true && (
              <Widgets
                open={isShown}
                onHide={() => setIsShown(false)}
                tenantId={tenantId}
              />
            )}
          </Container>
          </div>
    </>
  );
};

export default withAuthenticationRequired(AdminPage);